import { html } from "../../helpers/html-template.js";
import { validate } from "../../helpers/validate.js";
import { attributesFlexSchema } from "./attributes.js";
const scalarFlex = {
  name: "flex",
  tagName: "flex",
  tiptapName: "",
  attributeTransform: (_, attributes) => {
    const out = {};
    if ("row" in attributes) out.row = Boolean(attributes.row);
    if ("column" in attributes) out.column = Boolean(attributes.column);
    if ("grow" in attributes) out.grow = Number(attributes.grow);
    if ("align" in attributes)
      out.align = attributes.align;
    if ("justify" in attributes)
      out.justify = attributes.justify;
    return validate(attributesFlexSchema, out);
  },
  render: async () => {
    return html`
    <div class="flex">
      <ssg-children></ssg-children>
    </div>`;
  }
};
export {
  scalarFlex
};
//# sourceMappingURL=index.js.map
